export const TEST_DY_COOKIE = 'testDY';
export const FIRST_VISIT_TIMESTAMP = 'firstVisitDate';
export const FIRST_DAY_COOKIE = 'isFirstDay';
export const REAL_IP = 'realIp';
export const HTO_COOKIE_FOR_LANDING_URL = 'htoLandingUrl';
export const HTO_COOKIE_FOR_LANDING_PAGE = 'htoLandingPage';
export const VISITOR_ID = 'visitorId';
